<template>
  <el-container class="chat-page">
    <resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="chat-aside-width">
      <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
        <el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
      </div>
      <div class="chat-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24">
      </div>
      <virtual-scroller class="scroll-box" :items="showChats">
        <template v-slot="{ item }">
          <chat-item :chat="item" @click.native="onActiveItem(item)" @delete="onDelItem(item)" @info="onShowInfo(item)"
            @dnd="onDnd(item)" @top="onTop(item)" :active="item === chatStore.activeChat"></chat-item>
        </template>
      </virtual-scroller>
    </resizable-aside>
    <el-container class="chat-box">
      <chat-box v-if="activeChat && activeChat.type != 'SYSTEM'" :chat="activeChat"></chat-box>
      <chat-system-box v-if="activeChat && activeChat.type == 'SYSTEM'" :chat="activeChat"></chat-system-box>
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ChatSystemBox from "../components/chat/ChatSystemBox.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";
export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ChatSystemBox,
    ResizableAside,
    VirtualScroller
  },
  data() {
    return {
      searchText: "",
      messageContent: "",
      group: {},
      groupMembers: []
    }
  },
  methods: {
    onActiveItem(chat) {
      this.chatStore.setActiveChat(chat);
    },
    onDelItem(chat) {
      this.$confirm(`删除后记录将清空,确认删除与' ${chat.showName}'的聊天 ?`, '删除会话', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (chat.type == 'PRIVATE' || chat.type == 'GROUP') {
            const data = {
              chatId: chat.targetId
            }
            await this.$http({
              url: `/message/${chat.type.toLowerCase()}/deleteChat`,
              method: 'delete',
              data: data
            });
        }
        this.chatStore.removeChat(chat);
      });
    },
    onShowInfo(chat) {
      if (chat.type == 'PRIVATE') {
        this.$router.push("/home/friend?id=" + chat.targetId);
      } else if (chat.type == 'GROUP') {
        if (!this.groupStore.isGroup(chat.targetId)) {
          this.$message.error("您已不在群聊中，无法查看群资料")
          return;
        }
        this.$router.push("/home/group?id=" + chat.targetId);
      }
    },
    onDnd(chat) {
      if (chat.type == 'PRIVATE') {
        this.setFriendDnd(chat, chat.targetId, !chat.isDnd)
      } else {
        this.setGroupDnd(chat, chat.targetId, !chat.isDnd)
      }
    },
    setFriendDnd(chat, friendId, isDnd) {
      let formData = {
        friendId: friendId,
        isDnd: isDnd
      }
      this.$http({
        url: '/friend/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setDnd(friendId, isDnd)
        this.chatStore.setDnd(chat, isDnd)
      })
    },
    setGroupDnd(chat, groupId, isDnd) {
      let formData = {
        groupId: groupId,
        isDnd: isDnd
      }
      this.$http({
        url: '/group/dnd',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setDnd(groupId, isDnd)
        this.chatStore.setDnd(chat, isDnd)
      })
    },
    onTop(chat) {
      if (chat.type == 'PRIVATE') {
        this.setFriendTop(chat, chat.targetId, !chat.isTop)
      } else {
        this.setGroupTop(chat, chat.targetId, !chat.isTop)
      }
    },
    setFriendTop(chat, friendId, isTop) {
      let formData = {
        friendId: friendId,
        isTop: isTop
      }
      this.$http({
        url: '/friend/top',
        method: 'put',
        data: formData
      }).then(() => {
        this.friendStore.setTop(friendId, isTop)
        this.chatStore.setTop(chat, isTop)
      })
    },
    setGroupTop(chat, groupId, isTop) {
      let formData = {
        groupId: groupId,
        isTop: isTop
      }
      this.$http({
        url: '/group/top',
        method: 'put',
        data: formData
      }).then(() => {
        this.groupStore.setTop(groupId, isTop)
        this.chatStore.setTop(chat, isTop)
      })
    },
    isShowChat(chat) {
      return !this.searchText || chat.showName.includes(this.searchText)
    },
  },
  computed: {
    activeChat() {
      return this.chatStore.activeChat;
    },
    loading() {
      return this.chatStore.loading
    },
    showChats() {
      return this.chatStore.chats.filter(chat => this.isShowChat(chat));
    }
  }
}
</script>

<style lang="scss">
.chat-page {
  background: transparent;

  // 左侧会话列表 (glass-l1 贴边)
  > .resizable-aside,
  > [class*="aside"] {
    background:
      linear-gradient(180deg, rgba(255, 252, 243, 0.55), rgba(255, 252, 243, 0.45));
    backdrop-filter: blur(20px) saturate(140%);
    -webkit-backdrop-filter: blur(20px) saturate(140%);
    border-right: 0.5px solid var(--hairline-soft);
  }

  .header {
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 14px;
    gap: 8px;
    position: relative;

    // 底部 Aurora 微光分隔线
    &::after {
      content: '';
      position: absolute;
      left: 14px; right: 14px; bottom: 0;
      height: 1px;
      background: linear-gradient(90deg,
        rgba(91,141,238,0) 0%,
        rgba(91,141,238,0.20) 25%,
        rgba(168,139,255,0.24) 55%,
        rgba(255,175,204,0.18) 80%,
        rgba(91,141,238,0) 100%);
      opacity: 0.7;
      pointer-events: none;
    }

    // 搜索输入框 → 玻璃 chip
    .search-text :deep(.el-input__inner) {
      height: 34px;
      border-radius: 999px !important;
      background: rgba(255, 255, 255, 0.55) !important;
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      border: 0.5px solid var(--hairline-mid) !important;
      padding-left: 32px;
      letter-spacing: -0.1px;
      transition: all 220ms ease;

      &:focus, &:hover {
        border-color: rgba(91, 141, 238, 0.45) !important;
        background: rgba(255, 255, 255, 0.78) !important;
        box-shadow: 0 0 0 3px rgba(91, 141, 238, 0.12);
      }
    }
    .search-text :deep(.el-input__prefix) {
      color: var(--im-text-color-lighter);
      left: 10px;
    }
  }

  .scroll-box {
    padding: 4px 6px;
  }

  .chat-loading {
    height: 50px;
    background: rgba(91, 141, 238, 0.06);
    border-radius: var(--radius-sm);
    margin: 0 8px;

    .el-icon-loading {
      font-size: 24px;
      color: var(--aurora-blue);
    }

    .el-loading-text {
      color: var(--im-text-color-secondary);
    }

    .chat-loading-box {
      height: 100%;
    }
  }

  .chat-items {
    flex: 1;
  }
}
</style>
